export const Sort = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.3335 5.9999L7.52876 3.80464C7.78911 3.54429 8.21122 3.54429 8.47157 3.80464L10.6668 5.9999M10.6668 9.9999L8.47157 12.1952C8.21122 12.4555 7.78911 12.4555 7.52876 12.1952L5.3335 9.9999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Sort
